<div class="metric-settings-goals">
  <div class="goals-div">
    <h2 class="goals">Goals</h2>
    <button
      *ngIf="goals && goals.hasChangesToSave"
      mat-raised-button
      class="save-btn green-btn"
      (click)="saveGoalsClicked.emit()"
      [disabled]="goals.hasGoalErrors || goals.pending"
    >
      SAVE
    </button>
    <p *ngIf="goals.hasSavedSuccessfully" class="green-text goals-saved-text">
      Saved!
    </p>
  </div>
  <p class="description">
    Add district and/or school goals. Setting goals determines the color of
    overall results on district and school dashboards. Goals are applied to
    dashboards viewable by all users.
  </p>
  <p *ngIf="goals.pending || schools.pending" class="green-text">Loading...</p>
  <p *ngIf="goals.error" class="general-error">{{ goals.error }}</p>
  <goal-filter-row
    [schoolsData]="schools.data"
    [metric]="metric"
    [goals]="goals"
    [district]="district"
    (filterGoalValueChanged)="filterGoalValueChanged.emit($event)"
    (filterGoalInactiveChanged)="filterGoalInactiveChanged.emit($event)"
    (schoolLevelSelected)="schoolLevelSelected.emit($event)"
  ></goal-filter-row>
  <button
    mat-raised-button
    class="apply-to-btn green-btn"
    (click)="
      applyFilterGoal.emit({
        schools: schools.data.currentlyFilteredSchools,
        district: district.data,
        selectedSchoolLevel: schools.data.selectedSchoolLevel
      })
    "
  >
    APPLY TO {{ schools.data.selectedSchoolLevel }}
  </button>
  <div
    *ngIf="
      goals &&
      goals.updatedData &&
      (goals.updatedData | json) != '{}' &&
      !goals.pending
    "
  >
    <goal-row
      *ngIf="
        district && district.data && schools.data.selectedSchoolLevel == 'All'
      "
      [name]="district.data.name"
      [id]="district.data.id"
      [goal]="goals.updatedData[district.data.id]"
      [type]="'district'"
      [metric]="metric"
      (goalValueChanged)="goalValueChanged.emit($event)"
      (goalInactiveChecked)="goalInactiveChecked.emit($event)"
    ></goal-row>
    <goal-row
      *ngFor="let school of schools.data.currentlyFilteredSchools"
      [name]="school.officialSchoolName"
      [id]="school.systemSchoolId"
      [goal]="goals.updatedData[school.systemSchoolId]"
      [metric]="metric"
      (goalValueChanged)="goalValueChanged.emit($event)"
      (goalInactiveChecked)="goalInactiveChecked.emit($event)"
    ></goal-row>
  </div>
  <p *ngIf="goals && goals.error">{{ goals.error }}</p>
</div>
